var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert alert-success"},[_vm._v(" Merci ! Votre paiement a bien été accepté. Vos crédits vous seront attribués dans un instant. ")])])
}]

export { render, staticRenderFns }